import { render } from "./TotalNFRPaid.vue?vue&type=template&id=5e7a7810"
import script from "./TotalNFRPaid.vue?vue&type=script&lang=js"
export * from "./TotalNFRPaid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__